<div class="pr-large">
  @if (!formEnds()) {
    <form
      class="flex flex--column"
      [formGroup]="reactiveForm"
      [finFormErrorFocus]="reactiveForm"
      (ngSubmit)="onSubmit()"
    >
      <fcom-radio-item-group
        [options]="[{ value: RelativeQuestion.YES }, { value: RelativeQuestion.NO }]"
        [parentForm]="reactiveForm"
        [controlName]="DarksiteFormControl.RELATIVE"
        [translationPrefix]="'darksiteForm.relativeQuestion'"
        [isHorizontal]="true"
        [isRequired]="true"
      ></fcom-radio-item-group>

      @if (selectedRelative === RelativeQuestion.NO) {
        <div
          data-testid="relative-no"
          class="text-content"
          [innerHTML]="'darksiteForm.formEndNotAvailable' | finLocalization | finSafe: 'html'"
        ></div>
      }

      @if (selectedRelative === RelativeQuestion.YES) {
        <fin-select-input
          class="relative-selection"
          [displayMargin]="false"
          [parentForm]="reactiveForm"
          [controlName]="DarksiteFormControl.RELATION"
          [options]="[
            { value: RelationQuestion.BROTHER },
            { value: RelationQuestion.DAUGHTER },
            { value: RelationQuestion.FATHER },
            { value: RelationQuestion.MOTHER },
            { value: RelationQuestion.SISTER },
            { value: RelationQuestion.SON },
            { value: RelationQuestion.SPOUSE },
            { value: RelationQuestion.OTHER },
          ]"
          [selectLabelTranslationKey]="'darksiteForm.relationQuestion.placeholder'"
          [translationPrefix]="'darksiteForm.relationQuestion'"
        ></fin-select-input>

        @if (SelectedRelation === RelationQuestion.OTHER) {
          <fcom-text-input
            [parentForm]="reactiveForm"
            [controlName]="DarksiteFormControl.OTHER"
            [translationPrefix]="'darksiteForm.other'"
            [displayMargin]="false"
          ></fcom-text-input>
        }

        <p class="text-content">{{ 'darksiteForm.informationAboutYou' | finLocalization }}</p>

        <div class="flex flex--space-between columns-2">
          <div class="column">
            <fcom-text-input
              [parentForm]="reactiveForm"
              [controlName]="DarksiteFormControl.FIRST_NAME"
              [translationPrefix]="'darksiteForm.firstName'"
              [displayMargin]="false"
            ></fcom-text-input>
          </div>
          <div class="column">
            <fcom-text-input
              [parentForm]="reactiveForm"
              [controlName]="DarksiteFormControl.LAST_NAME"
              [translationPrefix]="'darksiteForm.lastName'"
              [displayMargin]="false"
            ></fcom-text-input>
          </div>
        </div>

        <fcom-text-input
          [parentForm]="reactiveForm"
          [controlName]="DarksiteFormControl.PHONE_NUMBER"
          [placeHolder]="'darksiteForm.phoneNumber.placeholder'"
          [translationPrefix]="'darksiteForm.phoneNumber'"
          [displayMargin]="false"
        ></fcom-text-input>

        <fcom-text-input
          [parentForm]="reactiveForm"
          [controlName]="DarksiteFormControl.MOBILE_NUMBER"
          [placeHolder]="'darksiteForm.mobileNumber.placeholder'"
          [translationPrefix]="'darksiteForm.mobileNumber'"
          [displayMargin]="false"
        ></fcom-text-input>

        <fcom-text-input
          [parentForm]="reactiveForm"
          [controlName]="DarksiteFormControl.EMAIL_ADDRESS"
          [translationPrefix]="'darksiteForm.emailAddress'"
          [displayMargin]="false"
        ></fcom-text-input>

        <fcom-text-input
          [parentForm]="reactiveForm"
          [controlName]="DarksiteFormControl.HOME_ADDRESS"
          [translationPrefix]="'darksiteForm.homeAddress'"
          [displayMargin]="false"
          [placeHolder]="'darksiteForm.homeAddress.placeholder'"
        ></fcom-text-input>

        <p class="text-content">{{ 'darksiteForm.informationAboutPassenger' | finLocalization }}</p>

        <div class="flex flex--space-between columns-2">
          <div class="column">
            <fcom-text-input
              [parentForm]="reactiveForm"
              [controlName]="DarksiteFormControl.PAX_FIRST_NAME"
              [translationPrefix]="'darksiteForm.firstName'"
              [displayMargin]="false"
            ></fcom-text-input>
          </div>
          <div class="column">
            <fcom-text-input
              [parentForm]="reactiveForm"
              [controlName]="DarksiteFormControl.PAX_LAST_NAME"
              [translationPrefix]="'darksiteForm.lastName'"
              [displayMargin]="false"
            ></fcom-text-input>
          </div>
        </div>

        <fin-form-group
          class="block"
          [groupTranslationPrefix]="'darksiteForm.dateOfBirth'"
          [group]="passengerDOB"
          [names]="[DOBFormControl.DAY, DOBFormControl.MONTH, DOBFormControl.YEAR]"
          [legend]="'darksiteForm.dateOfBirth.label' | finLocalization"
        >
          <div class="flex">
            <fin-select-input
              class="flex-1 flex--basis0 mr-xsmall-r"
              [controlName]="DOBFormControl.DAY"
              [parentForm]="passengerDOB"
              [options]="availableDays$ | async"
              [displayMargin]="false"
              [disableLabel]="true"
              [selectLabelTranslationKey]="'darksiteForm.dateOfBirth.daySelect'"
            >
            </fin-select-input>

            <fin-select-input
              class="flex-1 flex--basis0 mr-xsmall-r"
              [controlName]="DOBFormControl.MONTH"
              [parentForm]="passengerDOB"
              [options]="availableMonths$ | async"
              [displayMargin]="false"
              [disableLabel]="true"
              [selectLabelTranslationKey]="'darksiteForm.dateOfBirth.monthSelect'"
            >
            </fin-select-input>

            <fin-select-input
              class="flex-1 flex--basis0"
              [controlName]="DOBFormControl.YEAR"
              [parentForm]="passengerDOB"
              [options]="availableYears$ | async"
              [displayMargin]="false"
              [disableLabel]="true"
              [selectLabelTranslationKey]="'darksiteForm.dateOfBirth.yearSelect'"
            >
            </fin-select-input>
          </div>
        </fin-form-group>

        <fcom-text-input
          [parentForm]="reactiveForm"
          [controlName]="DarksiteFormControl.PAX_NATIONALITY"
          [translationPrefix]="'darksiteForm.nationality'"
          [displayMargin]="false"
        ></fcom-text-input>

        <fcom-text-input
          [parentForm]="reactiveForm"
          [controlName]="DarksiteFormControl.PAX_HOME_ADDRESS"
          [translationPrefix]="'darksiteForm.homeAddress'"
          [displayMargin]="false"
          [placeHolder]="'darksiteForm.homeAddress.placeholder'"
        ></fcom-text-input>

        <fcom-text-input
          [parentForm]="reactiveForm"
          [controlName]="DarksiteFormControl.COMPANION_NAME"
          [translationPrefix]="'darksiteForm.companionName'"
          [displayMargin]="false"
        ></fcom-text-input>

        <fcom-button
          [aria]="{
            label: 'darksiteForm.submitText' | finLocalization,
            loadingLabel: 'actions.loading' | finLocalization,
            role: 'button',
          }"
          [loading]="loading()"
          [mode]="ButtonMode.FILL"
          [size]="ButtonSize.LARGE"
          [type]="ButtonType.SUBMIT"
          [text]="'darksiteForm.submitText' | finLocalization"
        ></fcom-button>
      }
    </form>
  } @else {
    <div
      data-testid="form-end"
      class="text-content pr-clear-t"
      [innerHTML]="'darksiteForm.formEnd' | finLocalization | finSafe: 'html'"
    ></div>
  }
</div>
